module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1256.7884b025.png";